import React, { PureComponent } from 'react';
import Loader from 'components/loader';
import PropTypes from 'prop-types';
import FlipMove from 'react-flip-move';
import classnames from 'classnames';
import { debounce } from 'lodash';
import randomCategoryIcon from 'util/misc/random-category-icon';
import { pageLoaderEasingFn } from 'constants/transitions-props';

const ANIMATION_DURATION = 1000;

class PageLoader extends PureComponent {
    static propTypes = {
        useRandomIcon: PropTypes.bool,
    };

    static defaultProps = {
        useRandomIcon: false,
    };

    constructor(props) {
        super(props);

        this.uid = 0;

        this.state = {
            currentShowingIcon: randomCategoryIcon(),
        };
    }

    componentDidMount() {
        this.updateIcon();
    }

    componentWillUnmount() {
        this.updateIcon.cancel();
    }

    updateIcon = debounce(function() {
        this.uid++;
        this.setState({
            currentShowingIcon: randomCategoryIcon(this.state.currentShowingIcon),
        });
    }, ANIMATION_DURATION);

    get moveUp() {
        return {
            enterAnimation: {
                from: {
                    transform: 'translate(0, 200px)',
                    opacity: 0,
                },
                to: {
                    transform: '',
                },
            },
            leaveAnimation: {
                from: {
                    transform: '',
                },
                to: {
                    transform: 'translate(0, -200px)',
                    opacity: 0,
                },
            },
        };
    }

    renderIconLoader() {
        const { currentShowingIcon } = this.state;
        return (
            <FlipMove
                className="page-loader--swiped"
                duration={ANIMATION_DURATION}
                easing={pageLoaderEasingFn}
                onFinish={this.updateIcon.bind(this)}
                {...(this.moveUp)}
            >
                {currentShowingIcon &&
                    <Loader
                        key={this.uid}
                        symbol={currentShowingIcon}
                        facet={'icon'}
                        size={'large'}
                        pulsate={false}/>
                }
            </FlipMove>
        );
    }

    render() {
        const { useRandomIcon } = this.props;

        return (
            <div className={ classnames('page-loader', { 'page-loader--large': useRandomIcon }) }>
                { useRandomIcon ? this.renderIconLoader() : <Loader/> }
            </div>
        );
    }
}

export default PageLoader;



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/page-loader/index.js